// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import mapstyle from 'assets/styleguide/mapstyle';
import StationDetailsModal from 'components/map/StationDetailsModal';
import Checkbox from 'components/map/Checkbox';
import { getLocations } from 'store/locations/actions';
import { GoogleMap, Marker, InfoBox, useLoadScript } from '@react-google-maps/api';
export function Map() {
    const dispatch = useDispatch();
    const mapRef = useRef();
    const locations = useSelector((state) => state.locations);
    const mapsApikey = process.env.RAZZLE_GOOGLE_MAPS_API_KEY;
    const [mapCenter] = useState({ lat: 52.5326, lng: 4.0913 });
    const zoom = 6;
    const [markerMap, markerMapUpdater] = useState({});
    const [selectedLocation, selectedLocationUpdater] = useState(null);
    const [stationModalOpen, stationModalOpenUpdater] = useState(false);
    const [isFiltered, isFilteredUpdater] = useState(false);
    const [filteredStations, filteredStationsUpdater] = useState([]);
    useEffect(() => {
        // Filter stations
        let filteredStationsInner = [];
        if (isFiltered) {
            Object.values(locations).map((location) => {
                const connectorArray = Object.values(location.connectors);
                connectorArray.map((connector) => {
                    const availableConnectorPowers = Object.keys(connector);
                    availableConnectorPowers.map((power) => {
                        if (+power >= 150) {
                            if (filteredStationsInner.indexOf(location) === -1) {
                                filteredStationsInner = [...filteredStationsInner, location];
                            }
                        }
                    });
                });
            });
        }
        else {
            filteredStationsInner = Object.values(locations);
        }
        filteredStationsUpdater(filteredStationsInner);
    }, [isFiltered, locations]);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: mapsApikey,
    });
    useEffect(() => {
        dispatch(getLocations());
    }, [dispatch]);
    // We have to create a mapping of our places to actual Marker objects
    const markerLoadHandler = (marker, location) => {
        return markerMapUpdater((prevState) => {
            return { ...prevState, [location.id]: marker };
        });
    };
    const markerClickHandler = (event, location) => {
        // Remember which place was clicked
        selectedLocationUpdater(location);
        // Required so clicking a 2nd marker works as expected
        if (stationModalOpen) {
            stationModalOpenUpdater(false);
        }
        stationModalOpenUpdater(true);
    };
    const loadHandler = (map) => {
        mapRef.current = map;
    };
    const getWindowOffset = (orientation) => {
        let windowOffset;
        let iconSize;
        let pinAnchor;
        switch (orientation) {
            case 'N':
                iconSize = { w: 26, h: 31 };
                pinAnchor = { x: 12.5, y: 0 };
                windowOffset = { x: -160, y: 5 };
                break;
            case 'NE':
                iconSize = { w: 28, h: 27 };
                pinAnchor = { x: 25, y: 0 };
                windowOffset = { x: -170, y: 5 };
                break;
            case 'E':
                iconSize = { w: 31, h: 27 };
                pinAnchor = { x: 30, y: 12.5 };
                windowOffset = { x: -176, y: -10 };
                break;
            case 'SE':
                iconSize = { w: 26, h: 27 };
                pinAnchor = { x: 25, y: 26 };
                windowOffset = { x: -172, y: -25 };
                break;
            case 'S':
                iconSize = { w: 26, h: 31 };
                pinAnchor = { x: 12.5, y: 30 };
                windowOffset = { x: -160, y: -25 };
                break;
            case 'SW':
                iconSize = { w: 26, h: 27 };
                pinAnchor = { x: 25, y: 26 };
                windowOffset = { x: -170, y: -25 };
                break;
            case 'W':
                iconSize = { w: 31, h: 27 };
                pinAnchor = { x: 0, y: 12.5 };
                windowOffset = { x: -140, y: -10 };
                break;
            case 'NW':
                iconSize = { w: 28, h: 27 };
                pinAnchor = { x: 0, y: 0 };
                windowOffset = { x: -145, y: 5 };
                break;
        }
        return {
            // eslint-disable-next-line no-undef
            windowOffset: new google.maps.Size(windowOffset.x, windowOffset.y),
            // eslint-disable-next-line no-undef
            scaledSize: new google.maps.Size(iconSize.w, iconSize.h),
            // eslint-disable-next-line no-undef
            anchor: new google.maps.Point(pinAnchor.x, pinAnchor.y),
        };
    };
    const renderMap = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "map filter", onClick: () => isFilteredUpdater(!isFiltered) },
                React.createElement(Checkbox, { checked: isFiltered, label: "150+ kW", onClick: () => isFilteredUpdater(!isFiltered) })),
            React.createElement(GoogleMap, { onLoad: loadHandler, center: mapCenter, zoom: zoom, options: {
                    styles: mapstyle,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                }, mapContainerStyle: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                } },
                filteredStations.map((location) => (React.createElement(Marker, { key: location.id, position: {
                        lat: parseFloat(location.coordinates.latitude),
                        lng: parseFloat(location.coordinates.longitude),
                    }, onLoad: (marker) => markerLoadHandler(marker, location), onClick: (event) => markerClickHandler(event, location), icon: {
                        anchor: getWindowOffset(location.orientation).anchor,
                        scaledSize: getWindowOffset(location.orientation).scaledSize,
                        url: location.available
                            ? require(`assets/markers/station_active_${location.orientation.toLowerCase()}.png`)
                            : require(`assets/markers/station_blocked_${location.orientation.toLowerCase()}.png`),
                    } }))),
                stationModalOpen && selectedLocation && (React.createElement(InfoBox, { anchor: markerMap[selectedLocation.id], options: {
                        alignBottom: true,
                        boxClass: 'station_modal desktop',
                        maxWidth: 280,
                        pixelOffset: getWindowOffset(selectedLocation.orientation).windowOffset,
                        enableEventPropagation: true,
                    } },
                    React.createElement(StationDetailsModal, { location: selectedLocation, onClose: () => stationModalOpenUpdater(false) })))),
            stationModalOpen && selectedLocation && (React.createElement("div", { className: "station_modal mobile" },
                React.createElement(StationDetailsModal, { location: selectedLocation, onClose: () => stationModalOpenUpdater(false) })))));
    };
    return isLoaded ? renderMap() : null;
}
